import type StoreService from '@ember-data/store';
import { Changeset } from 'ember-changeset';
import { type DetailedChangeset } from 'ember-changeset/types';
import lookupValidator from 'ember-changeset-validations';
import type GroupInviteModel from 'garaje/models/group-invite';
import type RecurringGroupInvite from 'garaje/models/recurring-group-invite';
import buildGroupInviteValidations from 'garaje/validations/group-invite';

type GroupInviteChangeset<T extends GroupInviteModel | RecurringGroupInvite> = DetailedChangeset<T>;

export interface GroupInviteValidationsOptions {
  hostFieldIsRequired?: boolean;
  checkEmailRequired?: boolean;
  store?: StoreService;
  recurring?: boolean;
}

export default function <T extends GroupInviteModel | RecurringGroupInvite>(
  groupInvite: T,
  options: GroupInviteValidationsOptions = {},
): GroupInviteChangeset<T> {
  const validations = buildGroupInviteValidations(options);
  const validator = lookupValidator(validations);

  return <GroupInviteChangeset<T>>Changeset(groupInvite, validator, validations);
}
